/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";

const CalendarToolbar = (toolbar) => {
  const [viewActive, setViewActive] = useState('month')

  const goToBack = () => {
    toolbar.onNavigate('PREV')
  }

  const goToNext = () => {
    toolbar.onNavigate('NEXT')
  }

  const goToCurrent = () => {
    toolbar.onNavigate('TODAY')
    toolbar.onView('month')
    setViewActive('month')
  }

  const viewDay = () => {
    toolbar.onView('day')
    setViewActive('day')
  }

  const viewWeek = () => {
    toolbar.onView('week')
    setViewActive('week')
  }
  
  const viewMonth = () => {
    toolbar.onView('month')
    setViewActive('month')
  }

  const { L, label } = toolbar
  return (
    <div className="big-calendar-header d-flex align-items-center justify-content-between flex-wrap">
      <div className="w-100 d-block d-sm-none text-center mb-4 font-weight-bold">
        {label}
      </div>

      <div className="d-flex">
        <button type="button" className="btn btn-primary calendar-today-btn mr-2 d-none d-sm-block d-md-block d-lg-block d-xl-block" onClick={toolbar.toggle}>{L["main.create"]}</button>
        <div role="group" className="mr-1 btn-group-xs btn-group">
          <button className={`${viewActive === 'month' ? 'active' : ''} btn btn-primary`} onClick={viewMonth}>{L["main.month"]}</button>
          <button className={`${viewActive === 'week' ? 'active' : ''} btn btn-primary`} onClick={viewWeek}>{L["main.week"]}</button>
          <button className={`${viewActive === 'day' ? 'active' : ''} btn btn-primary`} onClick={viewDay}>{L["main.day"]}</button>
        </div>
      </div>

      <div className="d-none d-sm-block d-md-block d-lg-block d-xl-block font-weight-bold">
        {label}
      </div>

      <div>
        <button type="button" className="btn btn-primary calendar-today-btn mr-2" onClick={goToCurrent}>{L["main.today"]}</button>
        <button type="button" className="btn calendar-prev-btn mr-1" onClick={goToBack}>
          <span className="simple-icon-arrow-left" />
        </button>
        <button type="button" className="btn calendar-next-btn" onClick={goToNext}>
          <span className="simple-icon-arrow-right" />
        </button>
      </div>
    </div>
  )
}
export default CalendarToolbar;
